
import React from "react";
import { Questionnaire } from "./Questionnaire";
import MinimalNavbar from "./MinimalNavbar";
import Share from "./Share";
import Contact from "./Contact";
import About from "./About";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import "./App.css";
import "./styles/backgrounds.css";
import logoMobile from './assets/logo_mobile.webp';

function Home() {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate("/quiz");
  };

return (
  <>
    <div className="navbar-container">
      <MinimalNavbar />
    </div>

<img
  src={logoMobile}
  alt="Logo décoratif"
  className="homepage-logo-bg"
/>
    <div className="page-background home-background">
      <div className="home-wrapper"> 
<div className="homepage-text">
  <h1 className="homepage-title">
    Et si un livre <br /> pouvait tout changer ?
  </h1>

  <div className="homepage-description">
    <p>
       Sur <strong>Monprochainlivre.fr</strong> on vous aide à trouver en quelques secondes le livre le plus adapté à vos besoins. <br />
        Pas de blabla, pas d'inscription, juste un court questionnaire et des recommandations basées sur une sélection des meilleurs ouvrages pour :<br /><br />
      - Faire le plein d’inspiration et réveiller de nouvelles idées ,<br />
      - Développer vos talents et booster votre confiance, <br />
      - Retrouver équilibre et bien-être grâce à des lectures qui font du bien.
    </p>

    <button className="cta-button" onClick={handleStart}>
      Prêt à découvrir votre prochaine lecture ?
    </button>

    <p className="info-message">
      Cliquez sur le bouton ci-dessus et laissez-vous guider : une réponse rapide, des 
      suggestions sur-mesure et peut-être … un livre qui changera votre vie !  
    </p>
  </div>
</div>

      </div> 
    </div>
  </>
);

}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quiz" element={<Questionnaire />} />
        <Route path="/partage" element={<Share />} />
        <Route path="/a-propos" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
